var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 0.742676C5.29973 0.742676 0.680176 5.36223 0.680176 11.0607C0.680176 16.2107 4.45332 20.4794 9.38604 21.2535V14.0433H6.76622V11.0607H9.38604V8.78754C9.38604 6.20158 10.9265 4.77317 13.2833 4.77317C14.4123 4.77317 15.593 4.97469 15.593 4.97469V7.51391H14.292C13.0103 7.51391 12.6104 8.30932 12.6104 9.1253V11.0607H15.4721L15.0146 14.0433H12.6104V21.2535C17.5432 20.4794 21.3163 16.2109 21.3163 11.0607C21.3163 5.36223 16.6968 0.742676 10.9982 0.742676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7c4a3a5033d3e0e39bdb132d79435631.svg";
export { ForwardRef as ReactComponent };